import getValueOffPercent from 'lib/offer/getValueOffPercent'
import { isMaldivesCharterBundleOffer } from 'constants/charterFlight'

interface CharterBundleHotelOnlyDiscount {
  discountPercent?: number
  memberDiscountPercent?: number
}

/**
 * The flight leg of a Maldives charter bundle carries no discount of its own, so a discount
 * computed off the bundle total (hotel + flight) is diluted toward the flight's zero.
 * `lowestPricePackage` is the offer's hotel-only pricing (room-rate data, never includes the
 * flight), so it yields the hotel's real discount %. Returns an empty object for non-charter
 * offers or when hotel pricing is absent, so callers keep their own bundle discount unchanged.
 */
export default function getCharterBundleHotelOnlyDiscount(offer: App.Offer | App.OfferSummary | undefined): CharterBundleHotelOnlyDiscount {
  if (!isMaldivesCharterBundleOffer(offer)) {
    return {}
  }
  const pkg = offer?.lowestPricePackage
  if (!pkg?.value || !pkg.price) {
    return {}
  }
  return {
    discountPercent: getValueOffPercent(pkg.value, pkg.price),
    memberDiscountPercent: pkg.memberPrice
      ? getValueOffPercent(pkg.memberValue || pkg.value, pkg.memberPrice)
      : undefined,
  }
}
